import { render } from "./LabelLight.vue?vue&type=template&id=b60a19a2&scoped=true"
import script from "./LabelLight.vue?vue&type=script&lang=js"
export * from "./LabelLight.vue?vue&type=script&lang=js"

import "./LabelLight.vue?vue&type=style&index=0&id=b60a19a2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b60a19a2"]])

export default __exports__